export declare namespace NotificationModalTokenSections {
	interface Icon {
		success: {
			color: string;
		};
		danger: {
			color: string;
		};
		warn: {
			color: string;
		};
		info: {
			color: string;
		};
	}
}

export type NotificationModalTokens = {
	icon: NotificationModalTokenSections.Icon;
};

export const icon: NotificationModalTokenSections.Icon = {
	success: { color: '{green.500}' },
	danger: { color: '{red.500}' },
	warn: { color: '{yellow.500}' },
	info: { color: '{primary.500}' },
};

/** `app-notification-modal` status icon colours (`css/notificationModal`). */
export default {
	icon,
} satisfies NotificationModalTokens;
